import React, {
  useState,
  ChangeEvent,
  useEffect,
  useRef,
  useMemo,
} from "react";
import {
  getInspectionById,
  scheduleInspection,
  updateInspection,
} from "../../api/apimethods";
import { useNavigate, useLocation } from "react-router-dom";
import ReCAPTCHA from "react-google-recaptcha";
import { countryMobileCodes } from "../../scripts/countryMobileCodes";
import { IInspectApplicationRequest } from "../../typings/interfaces/Requests/InspectApplicationRequest";
import { Holiday } from "../../typings/models/Holiday";
import fetchHolidaysMaster from "../../scripts/holidaysMaster";
import { IcountryOptions } from "../../typings/models/CountryOption";
import fetchCountryOptions from "../../scripts/countryOptions";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { setHours, setMinutes } from 'date-fns';
import { AppContext, defaultAppContextData } from "../../services/appData";
import { useConfig } from "../../context/ConfigProvider";
import { useAuthService, useContextService } from "../../services";
import Loader from "../../components/molecules/Loader";

const ISRInspectionApplication: React.FC = () => {
  const { getContextValueFromStorage } = useContextService();
  const [contextData] = useState(() =>
    getContextValueFromStorage(defaultAppContextData)
  );
  const user = contextData.user;

  const inputHolidayRef = useRef(true);
  const inputCountryRef = useRef(true);
  const [errorMessage, setErrorMessage] = useState("");
  const [isalutation, setiSalutation] = useState("0");
  const [iapplicantName, setiApplicantName] = useState("");
  const [iUEN, setiUEN] = useState("");
  const [icompanyName, setiCompanyName] = useState("");
  const [ilicencenumber, setiLicenceNumber] = useState("");
  const [iorganizationAddress, setiOrganizationAddress] = useState("");
  const [iorganizationAddress2, setiOrganizationAddress2] = useState("0");
  const [iorganizationAddress3, setiOrganizationAddress3] = useState("");
  const [iorganizationAddress4, setiOrganizationAddress4] = useState("");
  const [iorganizationAddress5, setiOrganizationAddress5] = useState("");
  const [iorganizationAddress6, setiOrganizationAddress6] = useState("");
  const [iorganizationAddress7, setiOrganizationAddress7] = useState("");
  const [iorganizationAddress8, setiOrganizationAddress8] = useState("");
  const [iorganizationAddress9, setiOrganizationAddress9] = useState("");
  const [iorganizationAddress10, setiOrganizationAddress10] = useState("");
  const [imobileNo, setiMobileNo] = useState("");
  const [imobilecode, setiMobileCode] = useState("+65");
  const [iemail, setiEmail] = useState("");

  const [aorganizationAddress, setaOrganizationAddress] = useState("");
  const [aorganizationAddress2, setaOrganizationAddress2] = useState("0");
  const [aorganizationAddress3, setaOrganizationAddress3] = useState("");
  const [aorganizationAddress4, setaOrganizationAddress4] = useState("");
  const [aorganizationAddress5, setaOrganizationAddress5] = useState("");
  const [aorganizationAddress6, setaOrganizationAddress6] = useState("");
  const [aorganizationAddress7, setaOrganizationAddress7] = useState("");
  const [aorganizationAddress8, setaOrganizationAddress8] = useState("");
  const [aorganizationAddress9, setaOrganizationAddress9] = useState("");
  const [aorganizationAddress10, setaOrganizationAddress10] = useState("");

  const [ainspectionDateTime, setainspectionDateTime] = useState<Date | null>(
    null
  );
  const [ainspectionTime, setaInspectionTime] = useState<Date | null>(
    setHours(setMinutes(new Date(), 0), 9)
  );
  const [aRemarks, setaRemarks] = useState("");
  const [aModeofContact, setaModeofContact] = useState<number>(0);
  const [amobileNo, setaMobileNo] = useState("");
  const [amobilecode, setaMobileCode] = useState("+65");

  const [validEmail, setValidEmail] = useState(true);
  const [submitted, setSubmitted] = useState(false);
  const [checkboxChecked, setCheckboxChecked] = useState(false);
  const [isalutationSelected, setiSalutationSelected] = useState(false);
  const [modeofContactSelected, setaModeofContactSelected] = useState(false);
  const recaptchaRef = useRef<ReCAPTCHA>(null);
  const cfg = useConfig();
  const site_Key: string = cfg.REACT_APP_SITE_KEY ?? "";
  //Date validation
  const currentDate = new Date();
  currentDate.setDate(currentDate.getDate() + 1); // Set it to tomorrow
  const minDate = currentDate; //.toISOString().split("T");

  const [floorNoShowError, setfloorNoShowError] = useState(true);
  const [unitNoShowError, setunitNoShowError] = useState(true);
  const [blockNoShowError, setblockNoShowError] = useState(true);
  const [postalCodeShowError, setpostalCodeShowError] = useState(true);
  const [validMobileNo, setValidMobileNo] = useState(true);
  const [afloorNoShowError, setafloorNoShowError] = useState(true);
  const [aunitNoShowError, setaunitNoShowError] = useState(true);
  const [ablockNoShowError, setablockNoShowError] = useState(true);
  const [apostalCodeShowError, setapostalCodeShowError] = useState(true);
  const [validaMobileNo, setValidaMobileNo] = useState(true);
  const [isCaptchaValid, setIsCaptchaValid] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [isSubmiting, setSubmiting] = useState(false);
  const [isValidDate, setisValidDate] = useState(true);
  const [isTimeValid, setTimeValid] = useState(true);
  const [holidays, setHolidays] = useState<Holiday[]>([]);
  const [countries, setCountries] = useState<IcountryOptions[]>([]);
  const [inspectionCaseId, setInspectionCaseId] = useState("");
  const [viewMode, setViewMode] = useState(true);
  const [disableInspectionDate, setDisableInspectionDate] = useState(true);
  const fileInputRef = useRef<HTMLInputElement>(null);
  const [selectedFiles, setSelectedFiles] = useState<File[]>([]);
  const [base64Files, setBase64Files] = useState<
    { fileName: string; file: string }[]
  >([]);
  const [uploadedFiles, setUploadedFiles] = useState<string[]>([]);
  const [disableUpload, setDisableUpload] = useState(true);
  const [disableSubmit, setDisableSubmit] = useState(true);
  let navigate = useNavigate();

  const location = useLocation();
  let inspectionId = location.state?.id;
  let applicationStatus = location.state?.status;
  const handleUploadButtonClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const files = event.target.files;
    const blockedExtensions = ["exe", "cmd"];

    if (files) {
      const newFileArray = Array.from(files);

      // Validate each file
      const isValidFiles = newFileArray.every((file) => {
        const fileExtension = file.name.split(".").pop()?.toLowerCase();
        const blockedExtensions = ["exe", "cmd"];

        if (
          fileExtension != undefined &&
          blockedExtensions.includes(fileExtension)
        )
          return false;
        else return true;
      });

      if (!isValidFiles)
        alert("Invalid file type. Please select files with valid extensions.");
      else if (
        uploadedFiles.length + selectedFiles.length + files.length >
        10
      ) {
        alert("You can only upload up to 10 files.");
      } else {
        const base64Promises = Array.from(files).map((file) => {
          return new Promise<{ fileName: string; file: string }>((resolve) => {
            const reader = new FileReader();
            reader.onload = (e) => {
              if (e.target) {
                const result = e.target.result as string;
                resolve({ fileName: file.name, file: result.split(",")[1] });
              }
            };
            reader.readAsDataURL(file);
          });
        });
        Promise.all(base64Promises).then((base64Array) => {
          setBase64Files([...base64Files, ...base64Array]);
        });

        setSelectedFiles([...selectedFiles, ...Array.from(files)]);
      }
    }
  };

  const removeSelectedFile = (index: number) => {
    if (window.confirm("Are you sure you want to remove this file?")) {
      if (index > -1 && index < selectedFiles.length) {
        const newSelectedFiles = [...selectedFiles];
        newSelectedFiles.splice(index, 1);
        const newBase64Files = [...base64Files];
        newBase64Files.splice(index, 1);

        // Update the state with the new array
        setSelectedFiles(newSelectedFiles);
        setBase64Files(newBase64Files);
      }
    }
  };

  const isWeekend = (date: any) => {
    const day = date.getDay();
    return day === 0 || day === 6; // Sunday (0) or Saturday (6)
  };

  const isHoliday = (date: any) => {
    const dateString = date.toISOString().split("T");
    return holidays.some((holiday) =>
      holiday.holidayDate.split("T").includes(dateString)
    );
  };

  const fixTimezoneOffset = (date: Date | null): Date | null => {
    if (!date) return null;
    return new Date(date.getTime() - date.getTimezoneOffset() * 60000);
  };

  const getTimezoneOffset = (date: Date): Date | null => {
    const newDate = new Date(date);
    const userTimezoneOffset = Math.abs(newDate.getTimezoneOffset() * 60000);
    return new Date(newDate.getTime() - userTimezoneOffset);
  };

  // Handle holiday vaidation
  const handleDateChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const selectedDate = event.target.value;
    const selectedDateObj = new Date(selectedDate);

    if (isWeekend(selectedDateObj) || isHoliday(selectedDateObj)) {
      // If the selected date is a weekend or a holiday, prevent updating the state
      event.preventDefault();
      setisValidDate(false);
      // setainspectionDateTime("");
    } else {
      // setainspectionDateTime(selectedDate);
      setisValidDate(true);
    }
  };

  //time validation
  const isValidTime = (time: any) => {
    const selectedTime = new Date(`2000-01-01T${time}`);
    const minTime = new Date(`2000-01-01T09:00`);
    const maxTime = new Date(`2000-01-01T17:00`);

    return selectedTime >= minTime && selectedTime <= maxTime;
  };

  const convertTo24HourFormat = (time: any) => {
    const [hours, minutes] = time.split(":");
    let hoursInt = parseInt(hours, 10);
    if (hoursInt < 12 && time.includes("PM")) {
      hoursInt += 12;
    }
    return `${hoursInt.toString().padStart(2, "0")}:${minutes}`;
  };

  const blockNoHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    const pattern = /^[a-zA-Z0-9\s]+$/;

    if (new RegExp(pattern).test(value)) {
      setiOrganizationAddress3(value);
      setblockNoShowError(true);
    } else {
      if (value === "") {
        setiOrganizationAddress3(value);
        setblockNoShowError(true);
      } else {
        setblockNoShowError(false);
      }
    }
  };
  const ablockNoHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    const pattern = /^[a-zA-Z0-9\s]+$/;

    if (new RegExp(pattern).test(value)) {
      setaOrganizationAddress3(value);
      setablockNoShowError(true);
    } else {
      if (value === "") {
        setaOrganizationAddress3(value);
        setablockNoShowError(true);
      } else {
        setablockNoShowError(false);
      }
    }
  };

  const postalCodeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    const pattern = /^[0-9]+$/;

    if (new RegExp(pattern).test(value)) {
      setiOrganizationAddress9(value);
      setpostalCodeShowError(true);
    } else {
      if (value === "") {
        setiOrganizationAddress9(value);
        setpostalCodeShowError(true);
      } else {
        setpostalCodeShowError(false);
      }
    }
  };

  const apostalCodeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    const pattern = /^[0-9]+$/;

    if (new RegExp(pattern).test(value)) {
      setaOrganizationAddress9(value);
      setapostalCodeShowError(true);
    } else {
      if (value === "") {
        setaOrganizationAddress9(value);
        setapostalCodeShowError(true);
      } else {
        setapostalCodeShowError(false);
      }
    }
  };

  const unitNoHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    const pattern = /^[a-zA-Z0-9s]+$/;

    if (new RegExp(pattern).test(value)) {
      setiOrganizationAddress7(value);
      setunitNoShowError(true);
    } else {
      if (value === "") {
        setiOrganizationAddress7(value);
        setunitNoShowError(true);
      } else {
        setunitNoShowError(false);
      }
    }
  };
  const aunitNoHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    const pattern = /^[a-zA-Z0-9\s]+$/;

    if (new RegExp(pattern).test(value)) {
      setaOrganizationAddress7(value);
      setaunitNoShowError(true);
    } else {
      if (value === "") {
        setaOrganizationAddress7(value);
        setaunitNoShowError(true);
      } else {
        setaunitNoShowError(false);
      }
    }
  };

  const floorNoHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    const pattern = "^[a-zA-Z0-9s]+$";

    if (new RegExp(pattern).test(value)) {
      setiOrganizationAddress6(value);
      setfloorNoShowError(true);
    } else {
      if (value === "") {
        setiOrganizationAddress6(value);
        setfloorNoShowError(true);
      } else {
        setfloorNoShowError(false);
      }
    }
  };

  const afloorNoHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    const pattern = "^[a-zA-Z0-9s]+$";

    if (new RegExp(pattern).test(value)) {
      setaOrganizationAddress6(value);
      setafloorNoShowError(true);
    } else {
      if (value === "") {
        setaOrganizationAddress6(value);
        setafloorNoShowError(true);
      } else {
        setafloorNoShowError(false);
      }
    }
  };

  const mobileNoHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    const pattern = /^[0-9]+$/;

    if (pattern.test(value)) {
      setiMobileNo(value);
      if (value.length >= 8) {
        setValidMobileNo(true);
      } else {
        setValidMobileNo(false);
      }
    } else {
      if (value === "") {
        setiMobileNo(value);
        setValidMobileNo(true);
      } else {
        setValidMobileNo(false);
      }
    }
  };

  const amobileNoHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    const pattern = /^[0-9]+$/;

    if (pattern.test(value)) {
      setaMobileNo(value);
      if (value.length >= 8) {
        setValidaMobileNo(true);
      } else {
        setValidaMobileNo(false);
      }
    } else {
      if (value === "") {
        setaMobileNo(value);
        setValidaMobileNo(true);
      } else {
        setValidaMobileNo(false);
      }
    }
  };

  useEffect(() => {
    if (inspectionId != undefined) {
      setInspectionCaseId(inspectionId);
      try {
        const fetchDataToEdit = async () => {
          var response = null;

          response = await getInspectionById(inspectionId);

          if (response.data) {
            if (response.data.inspectionStatus === 1) {
              setDisableInspectionDate(false);
              setDisableSubmit(false);
            } else {
              setDisableInspectionDate(true);
              setDisableSubmit(true);
            }
            if (
              response.data.inspectionResult === 6 ||
              response.data.inspectionStatus === 2 ||
              response.data.inspectionStatus === 3 ||
              response.data.inspectionStatus === 7 ||
              response.data.inspectionStatus === 10 ||
              response.data.inspectionStatus === 11
            ) {
              setDisableUpload(false);
              setDisableSubmit(false);
            } else {
              setDisableUpload(true);
              setDisableSubmit(true);
            }
            if (response.data.salutation != undefined)
              setiSalutation(response.data.salutation);
            setiApplicantName(response.data.name);
            setiUEN(response.data.uen);
            if (response.data.companyName != undefined)
              setiCompanyName(response.data.companyName);
            if (response.data.mobileNo != undefined)
              setiMobileNo(response.data.mobileNo.slice(-8));
            if (response.data.email != undefined)
              setiEmail(response.data.email);
            if (response.data.addressType != undefined)
              setiOrganizationAddress(response.data.addressType);
            if (response.data.typeofPremises != undefined)
              setiOrganizationAddress2(response.data.typeofPremises);
            if (response.data.blockHouseNumber != undefined)
              setiOrganizationAddress3(response.data.blockHouseNumber);
            if (response.data.streetName != undefined)
              setiOrganizationAddress5(response.data.streetName);
            if (response.data.floorNumber != undefined)
              setiOrganizationAddress6(response.data.floorNumber);
            if (response.data.unitNumber != undefined)
              setiOrganizationAddress7(response.data.unitNumber);
            if (response.data.buildingName != undefined)
              setiOrganizationAddress8(response.data.buildingName);
            if (response.data.postalCode != undefined)
              setiOrganizationAddress9(response.data.postalCode);
            if (response.data.country != undefined)
              setiOrganizationAddress10(response.data.country);
            if (response.data.insAppOrganizationAddress != undefined)
              setaOrganizationAddress(response.data.insAppOrganizationAddress);
            if (response.data.insAppTypeofPremises != undefined)
              setaOrganizationAddress2(response.data.insAppTypeofPremises);
            if (response.data.insAppBlockHouseNumber != undefined)
              setaOrganizationAddress3(response.data.insAppBlockHouseNumber);
            if (response.data.insAppStreetName != undefined)
              setaOrganizationAddress5(response.data.insAppStreetName);
            if (response.data.insAppFloorNumber != undefined)
              setaOrganizationAddress6(response.data.insAppFloorNumber);
            if (response.data.insAppUnitNumber != undefined)
              setaOrganizationAddress7(response.data.insAppUnitNumber);
            if (response.data.insAppBuildingName != undefined)
              setaOrganizationAddress8(response.data.insAppBuildingName);
            if (response.data.insAppPostalCode != undefined)
              setaOrganizationAddress9(response.data.insAppPostalCode);
            if (response.data.insAppCountry != undefined)
              setaOrganizationAddress10(response.data.insAppCountry);
            if (response.data.inspectionDate != undefined)
              setainspectionDateTime(new Date(response.data.inspectionDate));

            if (response.data.inspectionTime != undefined) {
              let date = getTimezoneOffset(
                new Date(response.data.inspectionTime)
              );
              setaInspectionTime(date);
            }

            if (response.data.insAppRemarks != undefined)
              setaRemarks(response.data.insAppRemarks);
            if (response.data.insAppModeofContact != undefined)
              setaModeofContact(response.data.insAppModeofContact);
            if (response.data.insAppMobileNo != undefined)
              setaMobileNo(response.data.insAppMobileNo);
            if (response.data.insAppMobileNoCode != undefined)
              setaMobileNo(response.data.insAppMobileNoCode);
            // if (response.data.supportingDocuments.length > 0)
            //   setUploadedFiles(response.data.supportingDocuments);
            // else setUploadedFiles([]);
          } else {
            // API call failed
          }
          setCountries(countries);
          setIsLoading(false);
        };
        fetchDataToEdit();
      } catch (error) {
        setIsLoading(false);
      }
    }
  }, [inspectionId]);

  useEffect(() => {
    if (inputCountryRef.current) {
      inputCountryRef.current = false;
      const fetchData = async () => {
        const countries = await fetchCountryOptions();
        setCountries(countries);
        setIsLoading(false);
        const defaultCountry = countries.find(
          (option) => option.label === "Singapore"
        )?.value;
        if (defaultCountry !== undefined) {
          setiOrganizationAddress10(defaultCountry);
          setaOrganizationAddress10(defaultCountry);
        }
      };

      fetchData();
    }
  }, []);

  useEffect(() => {
    if (inputHolidayRef.current) {
      inputHolidayRef.current = false;
      const fetchHolidaysData = async () => {
        const holidaysData = await fetchHolidaysMaster();
        setHolidays(holidaysData);
      };

      fetchHolidaysData();
    }
  }, []);

  const handleCountryChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    var index = event.target.selectedIndex;
    setiOrganizationAddress10(event.target.options[index].text);
  };

  const ahandleCountryChange = (
    event: React.ChangeEvent<HTMLSelectElement>
  ) => {
    setaOrganizationAddress10(event.target.value);
  };

  if (isLoading) {
    return <Loader />;
  }

  async function handleSubmit(event: React.FormEvent<HTMLFormElement>) {
    event.preventDefault();
    try {
      setSubmitted(true);
      const reCaptchaResponse = recaptchaRef.current?.getValue();
      let saltuation = isSalutationSelected();
      let modeofContact = isModeofContactSelected();
      setiSalutationSelected(saltuation);
      setaModeofContactSelected(modeofContact);

      // if (!reCaptchaResponse) {
      //   // reCAPTCHA validation failed
      //   setIsCaptchaValid(false);
      //   return;
      // }
      if (isValidDate && checkboxChecked && saltuation && validEmail) {
        var response = null;
        setSubmiting(true);
        response = await updateInspection(
          inspectionCaseId,
          inspectionRequestData
        );
        if (response.data) {
          setSubmiting(false);
          // let path = `/isr-inspections`;
          // navigate(path, { state: { activeTab: "dashboard" } });
          let path = `/vethealth-inspection-complete`;
          navigate(path, { state: { type: "ISR" } });
        } else {
          // API call failed
          setSubmiting(false);
          const errorMessage = "An error occurred. Please try again.";
          setErrorMessage(errorMessage); // Set the error message in state
        }
      }
    } catch (error) {
      // Handle any errors
      setSubmiting(false);
      console.error(error);
    }
  }

  (function () {
    

    // Fetch all the forms we want to apply custom Bootstrap validation styles to
    var forms = document.querySelectorAll(".needs-validation");

    // Loop over them and prevent submission
    Array.prototype.slice.call(forms).forEach(function (form) {
      form.addEventListener(
        "submit",
        function (event: any) {
          if (!form.checkValidity()) {
            event.preventDefault();
            event.stopPropagation();
          }

          form.classList.add("was-validated");
        },
        false
      );
    });
  })();
  // Include the applicantName value in your API request
  // Prepare the request payload
  const inspectionRequestData: IInspectApplicationRequest = {
    personalInformation: {
      salutation: isalutation,
      name: iapplicantName,
      uen: iUEN,
      companyName: icompanyName,
      AddressType: iorganizationAddress,
      mobileNo: imobileNo,
      email: iemail,
      licenceNumber: ilicencenumber,
      premiseCode: "",
      typeofPremises: iorganizationAddress2,
      blockHouseNumber: iorganizationAddress3,
      houseNumber: iorganizationAddress4,
      streetName: iorganizationAddress5,
      floorNumber: iorganizationAddress6,
      unitNumber: iorganizationAddress7,
      buildingName: iorganizationAddress8,
      postalCode: iorganizationAddress9,
      country: iorganizationAddress10,
      mobileNoCode: imobilecode,
    },
    applicationInformation: {
      insAppTypeofPremises: aorganizationAddress2,
      insAppBlockHouseNumber: aorganizationAddress3,
      insAppHouseNumber: aorganizationAddress4,
      insAppStreetName: aorganizationAddress5,
      insAppFloorNumber: aorganizationAddress6,
      insAppUnitNumber: aorganizationAddress7,
      insAppBuildingName: aorganizationAddress8,
      insAppPostalCode: aorganizationAddress9,
      insAppCountry: aorganizationAddress10,
      insAppOrganizationAddress: aorganizationAddress,
      insAppHarvestDate: fixTimezoneOffset(ainspectionDateTime) ?? null,
      insAppHarvestTime: fixTimezoneOffset(ainspectionTime) ?? null,
      insAppRemarks: aRemarks,
      insAppMobileNoCode: amobilecode,
      insAppMobileNo: amobileNo,
      insAppModeofContact: aModeofContact,
      insContactMobile: imobileNo,
      insContactMobileCode: imobilecode,
      supportingDocuments: base64Files,
    },
    userInformation: {
      name: user?.name,
      idType: user?.idType,
      idNo: user?.idNo,
      email: user?.email,
      contactNo: user?.contactNo,
      companyName: user?.companyName,
      uen: user?.uen,
      registeredAddress: user?.registeredAddresses?.[0],
    },
  };

  const handleEmailChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    setiEmail(value);
    if (pattern.test(value)) {
      setValidEmail(true);
    } else {
      if (value === "") {
        setValidEmail(true);
      } else {
        setValidEmail(false);
      }
    }
  };

  const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setCheckboxChecked(event.target.checked);
  };

  const isSalutationSelected = () => {
    return isalutation !== null && isalutation !== "0";
  };
  const isModeofContactSelected = () => {
    return aModeofContact !== null && aModeofContact !== 0;
  };

  return (
    <>
      <h2>Declaration</h2>
      <div className="inst-cnt mb-2">
        <div className="form-check">
          <input
            className="form-check-input"
            type="checkbox"
            checked={checkboxChecked}
            onChange={handleCheckboxChange}
            id="flexCheckDefault"
            required
          />
          <label className="form-check-label" htmlFor="flexCheckDefault">
            I certify that the information given is true and complete to the
            best of my knowledge.
          </label>
          {submitted && !checkboxChecked && (
            <p className="error-message">
              Please confirm the declaration checkbox
            </p>
          )}
        </div>
      </div>
      <h2 className="pb-2">Registration</h2>
      <div className="inst-cnt mt-4 mb-2">
        <span className="est-time">
          <i className="fas fa-clock"></i> Estimated time to complete: 15 mins
        </span>
      </div>
      <form
        className="row g-3 needs-validation"
        onSubmit={handleSubmit}
        noValidate
      >
        <div
          className="passport-details hidden csp-display-block"
          id="passport"
        >
          <h2 className="pb-0">Personal Information</h2>
          <div className="inst-cnt mt-2">
            <div className="mb-2">
              <label
                htmlFor="exampleFormControlInput1"
                className={`form-label mb-2 ${
                  !isSalutationSelected() ? "required" : ""
                }`}
              >
                1. Salutation <span className="star">*</span>{" "}
              </label>
              <div
                className={`form-check ${
                  !isSalutationSelected() ? "is-invalid" : ""
                }`}
              >
                <input
                  className="form-check-input"
                  type="radio"
                  name="ssalutation"
                  value="Dr"
                  id="flexRadioDefault11"
                  checked={isalutation === "Dr"}
                  onChange={() => setiSalutation("Dr")}
                  disabled={viewMode}
                />
                <label
                  className="form-check-label"
                  htmlFor="flexRadioDefault11"
                >
                  Dr
                </label>
              </div>
              <div
                className={`form-check ${
                  !isSalutationSelected() ? "is-invalid" : ""
                }`}
              >
                <input
                  className="form-check-input"
                  type="radio"
                  name="ssalutation"
                  value="Mdm"
                  id="flexRadioDefault22"
                  checked={isalutation === "Mdm"}
                  onChange={() => setiSalutation("Mdm")}
                  disabled={viewMode}
                />
                <label
                  className="form-check-label"
                  htmlFor="flexRadioDefault22"
                >
                  Mdm
                </label>
              </div>
              <div
                className={`form-check ${
                  !isSalutationSelected() ? "is-invalid" : ""
                }`}
              >
                <input
                  className="form-check-input"
                  type="radio"
                  name="ssalutation"
                  value="Miss"
                  id="flexRadioDefault33"
                  checked={isalutation === "Miss"}
                  onChange={() => setiSalutation("Miss")}
                  disabled={viewMode}
                />
                <label
                  className="form-check-label"
                  htmlFor="flexRadioDefault33"
                >
                  Miss
                </label>
              </div>
              <div
                className={`form-check ${
                  !isSalutationSelected() ? "is-invalid" : ""
                }`}
              >
                <input
                  className="form-check-input"
                  type="radio"
                  name="ssalutation"
                  value="Mr"
                  id="flexRadioDefault55"
                  checked={isalutation === "Mr"}
                  onChange={() => setiSalutation("Mr")}
                  disabled={viewMode}
                />
                <label
                  className="form-check-label"
                  htmlFor="flexRadioDefault55"
                >
                  Mr
                </label>
              </div>
              <div
                className={`form-check ${
                  !isSalutationSelected() ? "is-invalid" : ""
                }`}
              >
                <input
                  className="form-check-input"
                  type="radio"
                  name="ssalutation"
                  value="Mrs"
                  id="flexRadioDefault66"
                  checked={isalutation === "Mrs"}
                  onChange={() => setiSalutation("Mrs")}
                  disabled={viewMode}
                />
                <label
                  className="form-check-label"
                  htmlFor="flexRadioDefault66"
                >
                  Mrs
                </label>
              </div>
              <div
                className={`form-check ${
                  !isSalutationSelected() ? "is-invalid" : ""
                }`}
              >
                <input
                  className="form-check-input"
                  type="radio"
                  name="ssalutation"
                  value="Ms"
                  id="flexRadioDefault66"
                  checked={isalutation === "Ms"}
                  onChange={() => setiSalutation("Ms")}
                  disabled={viewMode}
                />
                <label
                  className="form-check-label"
                  htmlFor="flexRadioDefault66"
                >
                  Ms
                </label>
              </div>
              {submitted && !isSalutationSelected() && (
                <div className="invalid-feedback">
                  Please select a Salutation.
                </div>
              )}
            </div>
            <div className="mb-2">
              <label htmlFor="sapplicantName" className="form-label mb-2">
                2. Name of Applicant <span className="star">*</span>{" "}
              </label>
              <input
                type="text"
                className="form-control"
                id="sapplicantName"
                placeholder="Type Applicant Name as per NRIC / Passport"
                value={iapplicantName}
                maxLength={255}
                onChange={(event) => setiApplicantName(event.target.value)}
                disabled={viewMode}
                required
              />
              <div className="invalid-feedback">
                Please provide a Applicant Name.
              </div>
            </div>
            <div className="mb-2 ">
              <label
                htmlFor="exampleFormControlInput1"
                className="form-label mb-2"
              >
                3. UEN <span className="star">*</span>
              </label>
              <input
                type="text"
                className="form-control"
                id="sUEN"
                placeholder=""
                maxLength={12}
                value={iUEN}
                onChange={(event) => setiUEN(event.target.value)}
                disabled={viewMode}
                required
              />
              <div className="invalid-feedback">Please provide a UEN.</div>
            </div>
            <div className="mb-2 ">
              <label
                htmlFor="exampleFormControlInput1"
                className="form-label mb-2"
              >
                4. Company Name
              </label>
              <input
                type="text"
                className="form-control"
                id="scompanyName"
                placeholder=""
                maxLength={100}
                value={icompanyName}
                onChange={(event) => setiCompanyName(event.target.value)}
                disabled={viewMode}
              />
            </div>
            <div className="mb-2 ">
              <label
                htmlFor="exampleFormControlInput1"
                className="form-label mb-2"
              >
                4. Licence Number
              </label>
              <input
                type="text"
                className="form-control"
                id="slicenceNumber"
                placeholder=""
                maxLength={100}
                value={ilicencenumber}
                onChange={(event) => setiLicenceNumber(event.target.value)}
                disabled={viewMode}
              />
            </div>
            <div className="mb-2 ">
              <label
                htmlFor="exampleFormControlInput1"
                className="form-label mb-2"
              >
                5. Organisational Address
              </label>
              <div className="row">
                <div className="col-lg-6">
                  <div className="mb-3 position-relative">
                    <select
                      className="form-select"
                      aria-label="Default select example"
                      id="sorganizationAddress"
                      //placeholder="Address Type"
                      value={iorganizationAddress}
                      onChange={(e) => setiOrganizationAddress(e.target.value)}
                      disabled={viewMode}
                      required
                    >
                      <option value="">Address Type</option>
                      <option value="1">Local</option>
                      <option value="2">Foreign</option>
                    </select>
                    <span
                      className="star csp-abs-ml-100-mt--30"
                    >
                      *
                    </span>
                    <div className="invalid-feedback mb-3">
                      Please provide an Address Type.
                    </div>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="mb-3">
                    <select
                      className="form-select"
                      aria-label="Default select example"
                      id="sorganizationAddress2"
                      value={iorganizationAddress2}
                      onChange={(e) => setiOrganizationAddress2(e.target.value)}
                      disabled={viewMode}
                    >
                      <option value="">Select Type of Premises</option>
                      <option value="1">Cold Room[CR]</option>
                      <option value="2">
                        Factory and Processing Plant[FPP]
                      </option>
                      <option value="3">Farm[FM]</option>
                      <option value="4">Food Factory[FF]</option>
                      <option value="5">Office[OF]</option>
                      <option value="6">Residential[RE]</option>
                      <option value="7">Retail Outlet[RO]</option>
                      <option value="8">Show Room[SR]</option>
                      <option value="9">Warehouse[WH]</option>
                      <option value="10">FeedMill[FM]</option>
                      <option value="11">Others[OTHERS]</option>
                    </select>
                  </div>
                </div>

                <div className="col-lg-6">
                  <div className="mb-3 position-relative">
                    <input
                      type="text"
                      className="form-control"
                      id="sorganizationAddress3"
                      placeholder="Block/House Number"
                      maxLength={4}
                      pattern="^[a-zA-Z0-9\s]+$"
                      value={iorganizationAddress3}
                      onChange={blockNoHandler}
                      disabled={viewMode}
                      required
                    />
                    <span
                      className="star csp-abs-ml-100-mt--30"
                    >
                      *
                    </span>

                    <div className="invalid-feedback mb-3">
                      Please provide a Block/House Num.
                    </div>
                    {!blockNoShowError && (
                      <div className="error-message">
                        Please enter charaters only. eg. "64FB"
                      </div>
                    )}
                  </div>
                </div>
                {/* <div className="col-lg-6">
                      <div className="mb-3">
                        <input
                          type="text"
                          className="form-control"
                          id="sorganizationAddress4"
                          placeholder="House Number"
                          maxLength={10}
                          value={sorganizationAddress4}
                          onChange={(event) =>
                            setsOrganizationAddress4(event.target.value)
                          }
                        />
                      </div>
                    </div> */}
                <div className="col-lg-6">
                  <div className="mb-3">
                    <input
                      type="text"
                      className="form-control"
                      id="sorganizationAddress6"
                      placeholder="Floor Number"
                      pattern="^[a-zA-Z0-9\s]+$"
                      value={iorganizationAddress6}
                      onChange={floorNoHandler}
                      disabled={viewMode}
                      maxLength={3}
                    />
                    {!floorNoShowError && (
                      <div className="error-message  mb-3">
                        Please enter numbers eg. "123"
                      </div>
                    )}
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="mb-3 position-relative">
                    <input
                      type="text"
                      className="form-control"
                      id="sorganizationAddress5"
                      placeholder="Street Name"
                      maxLength={64}
                      value={iorganizationAddress5}
                      onChange={(event) =>
                        setiOrganizationAddress5(event.target.value)
                      }
                      disabled={viewMode}
                      required
                    />
                    <span
                      className="star csp-abs-ml-100-mt--30"
                    >
                      *
                    </span>

                    <div className="invalid-feedback mb-3">
                      Please provide a Street Name.
                    </div>
                  </div>
                </div>

                <div className="col-lg-6">
                  <div className="mb-3">
                    <input
                      type="text"
                      className="form-control"
                      id="sorganizationAddress7"
                      placeholder="Unit Number"
                      pattern="^[a-zA-Z0-9\s]+$"
                      value={iorganizationAddress7}
                      onChange={unitNoHandler}
                      disabled={viewMode}
                      maxLength={4}
                    />
                    {!unitNoShowError && (
                      <div className="error-message  mb-3">
                        Please enter numbers eg. "1234"
                      </div>
                    )}
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="mb-3 position-relative">
                    <input
                      type="text"
                      className="form-control"
                      id="sorganizationAddress9"
                      placeholder="Postal Code"
                      maxLength={8}
                      pattern="[0-9]+"
                      value={iorganizationAddress9}
                      onChange={postalCodeHandler}
                      disabled={viewMode}
                      required
                    />
                    <span
                      className="star csp-abs-ml-100-mt--30"
                    >
                      *
                    </span>

                    <div className="invalid-feedback mb-3">
                      Please provide a Postal Code.
                    </div>
                    {!postalCodeShowError && (
                      <div className="error-message">
                        Please enter numbers only. eg. "123456"
                      </div>
                    )}
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="mb-3">
                    <input
                      type="text"
                      className="form-control"
                      id="sorganizationAddress8"
                      placeholder="Building Name"
                      maxLength={64}
                      value={iorganizationAddress8}
                      onChange={(event) =>
                        setiOrganizationAddress8(event.target.value)
                      }
                      disabled={viewMode}
                    />
                  </div>
                </div>

                <div className="col-lg-6">
                  <div className="mb-3 position-relative">
                    <select
                      className="form-select"
                      aria-label="Default select example"
                      id="sorganizationAddress10"
                      value={iorganizationAddress10}
                      onChange={handleCountryChange}
                      // value={sorganizationAddress10}
                      // onChange={(e) =>
                      //   setsOrganizationAddress10(e.target.value)
                      // }
                      disabled={viewMode}
                      required
                    >
                      {countries.map((option) => (
                        <option key={option.value} value={option.value}>
                          {option.label}
                        </option>
                      ))}
                    </select>
                    <span
                      className="star csp-abs-ml-100-mt--30"
                    >
                      *
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="mb-2">
              <label
                htmlFor="exampleFormControlInput1"
                className="form-label mb-2"
              >
                6. Mobile Number <span className="star">*</span>
              </label>

              <div className="row">
                <div className="col-md-2">
                  <select
                    className="form-select"
                    aria-label="Default select example"
                    id="smobilecode"
                    value={imobilecode}
                    onChange={(e) => setiMobileCode(e.target.value)}
                    disabled={viewMode}
                    required
                  >
                    {countryMobileCodes.map((code: any) => (
                      <option key={code} value={code}>
                        {code}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="col-md-10">
                  <input
                    type="text"
                    aria-describedby="emailHelp"
                    className="form-control"
                    id="smobileNo"
                    placeholder=""
                    pattern="[0-9]+"
                    value={imobileNo}
                    onChange={mobileNoHandler}
                    maxLength={8}
                    disabled={viewMode}
                    required
                  />
                  <div className="invalid-feedback">
                    Please provide a mobile.
                  </div>
                  {!validMobileNo && (
                    <div className="invalid-feedback">
                      Invalid mobile no. eg. +6591234567
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="mb-2">
              <label
                htmlFor="exampleFormControlInput1"
                className="form-label mb-2"
              >
                7. Email<span className="star">*</span>
              </label>
              <input
                type="email"
                className="form-control"
                id="semail"
                value={iemail}
                maxLength={255}
                onChange={handleEmailChange}
                placeholder="Enter email"
                disabled={viewMode}
                required
              />
              <div className="invalid-feedback">Please provide a email.</div>
              {!validEmail && (
                <p className="error-message">
                  Invalid email format. eg. abc@de.lk
                </p>
              )}
            </div>
          </div>
          <h2 className="pt-2 pb-0">Application Information</h2>
          <div className="inst-cnt mt-2">
            <div className="mb-2 ">
              <label
                htmlFor="exampleFormControlInput1"
                className="form-label mb-2"
              >
                8. Inspection Address
              </label>
              <div className="row">
                <div className="col-lg-6">
                  <div className="mb-3 position-relative">
                    <select
                      className="form-select"
                      aria-label="Default select example"
                      id="sorganizationAddress"
                      //placeholder="Address Type"
                      value={aorganizationAddress}
                      onChange={(e) => setaOrganizationAddress(e.target.value)}
                      disabled={viewMode}
                      required
                    >
                      <option value="">Address Type</option>
                      <option value="1">Local</option>
                      <option value="2">Foreign</option>
                    </select>
                    <span
                      className="star csp-abs-ml-100-mt--30"
                    >
                      *
                    </span>
                    <div className="invalid-feedback mb-3">
                      Please provide an Address Type.
                    </div>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="mb-3">
                    <select
                      className="form-select"
                      aria-label="Default select example"
                      id="sorganizationAddress2"
                      value={aorganizationAddress2}
                      onChange={(e) => setaOrganizationAddress2(e.target.value)}
                      disabled={viewMode}
                    >
                      <option value="">Select Type of Premises</option>
                      <option value="1">Cold Room[CR]</option>
                      <option value="2">
                        Factory and Processing Plant[FPP]
                      </option>
                      <option value="3">Farm[FM]</option>
                      <option value="4">Food Factory[FF]</option>
                      <option value="5">Office[OF]</option>
                      <option value="6">Residential[RE]</option>
                      <option value="7">Retail Outlet[RO]</option>
                      <option value="8">Show Room[SR]</option>
                      <option value="9">Warehouse[WH]</option>
                      <option value="10">FeedMill[FM]</option>
                      <option value="11">Others[OTHERS]</option>
                    </select>
                  </div>
                </div>

                <div className="col-lg-6">
                  <div className="mb-3 position-relative">
                    <input
                      type="text"
                      className="form-control"
                      id="sorganizationAddress3"
                      placeholder="Block/House Number"
                      maxLength={4}
                      pattern="^[a-zA-Z0-9\s]+$"
                      value={aorganizationAddress3}
                      onChange={ablockNoHandler}
                      disabled={viewMode}
                      required
                    />
                    <span
                      className="star csp-abs-ml-100-mt--30"
                    >
                      *
                    </span>

                    <div className="invalid-feedback mb-3">
                      Please provide a Block/House Num.
                    </div>
                    {!ablockNoShowError && (
                      <div className="error-message">
                        Please enter charaters only. eg. "64FB"
                      </div>
                    )}
                  </div>
                </div>
                {/* <div className="col-lg-6">
                      <div className="mb-3">
                        <input
                          type="text"
                          className="form-control"
                          id="sorganizationAddress4"
                          placeholder="House Number"
                          maxLength={10}
                          value={sorganizationAddress4}
                          onChange={(event) =>
                            setsOrganizationAddress4(event.target.value)
                          }
                        />
                      </div>
                    </div> */}
                <div className="col-lg-6">
                  <div className="mb-3">
                    <input
                      type="text"
                      className="form-control"
                      id="sorganizationAddress6"
                      placeholder="Floor Number"
                      pattern="^[a-zA-Z0-9\s]+$"
                      value={aorganizationAddress6}
                      onChange={afloorNoHandler}
                      disabled={viewMode}
                      maxLength={3}
                    />
                    {!afloorNoShowError && (
                      <div className="error-message  mb-3">
                        Please enter numbers eg. "123"
                      </div>
                    )}
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="mb-3 position-relative">
                    <input
                      type="text"
                      className="form-control"
                      id="sorganizationAddress5"
                      placeholder="Street Name"
                      maxLength={64}
                      value={aorganizationAddress5}
                      onChange={(event) =>
                        setaOrganizationAddress5(event.target.value)
                      }
                      disabled={viewMode}
                      required
                    />
                    <span
                      className="star csp-abs-ml-100-mt--30"
                    >
                      *
                    </span>

                    <div className="invalid-feedback mb-3">
                      Please provide a Street Name.
                    </div>
                  </div>
                </div>

                <div className="col-lg-6">
                  <div className="mb-3">
                    <input
                      type="text"
                      className="form-control"
                      id="sorganizationAddress7"
                      placeholder="Unit Number"
                      pattern="^[a-zA-Z0-9\s]+$"
                      value={aorganizationAddress7}
                      onChange={aunitNoHandler}
                      disabled={viewMode}
                      maxLength={4}
                    />
                    {!aunitNoShowError && (
                      <div className="error-message  mb-3">
                        Please enter numbers eg. "1234"
                      </div>
                    )}
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="mb-3 position-relative">
                    <input
                      type="text"
                      className="form-control"
                      id="sorganizationAddress9"
                      placeholder="Postal Code"
                      maxLength={8}
                      pattern="[0-9]+"
                      value={aorganizationAddress9}
                      onChange={apostalCodeHandler}
                      disabled={viewMode}
                      required
                    />
                    <span
                      className="star csp-abs-ml-100-mt--30"
                    >
                      *
                    </span>

                    <div className="invalid-feedback mb-3">
                      Please provide a Postal Code.
                    </div>
                    {!apostalCodeShowError && (
                      <div className="error-message">
                        Please enter numbers only. eg. "123456"
                      </div>
                    )}
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="mb-3">
                    <input
                      type="text"
                      className="form-control"
                      id="sorganizationAddress8"
                      placeholder="Building Name"
                      maxLength={64}
                      value={aorganizationAddress8}
                      onChange={(event) =>
                        setaOrganizationAddress8(event.target.value)
                      }
                      disabled={viewMode}
                    />
                  </div>
                </div>

                <div className="col-lg-6">
                  <div className="mb-3 position-relative">
                    <select
                      className="form-select"
                      aria-label="Default select example"
                      id="sorganizationAddress10"
                      value={aorganizationAddress10}
                      onChange={ahandleCountryChange}
                      disabled={viewMode}
                      // value={sorganizationAddress10}
                      // onChange={(e) =>
                      //   setsOrganizationAddress10(e.target.value)
                      // }
                      required
                    >
                      {countries.map((option) => (
                        <option key={option.value} value={option.value}>
                          {option.label}
                        </option>
                      ))}
                    </select>
                    <span
                      className="star csp-abs-ml-100-mt--30"
                    >
                      *
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="mb-2">
              <label
                htmlFor="exampleFormControlInput1"
                className="form-label mb-2"
              >
                9. Date of Inspection{" "}
                <span className="bracket-text">
                  (Please exclude public holidays and weekends)
                </span>{" "}
                <span className="star">*</span>
              </label>
              {/* <input
                type="date"
                className="form-control"
                id="sHarvestDate"
                value={ainspectionDateTime}
                onChange={handleDateChange}
                disabled={disableInspectionDate}
                min={minDate[0]}
                required
              /> */}
              <DatePicker
                id="sHarvestDate"
                selected={ainspectionDateTime}
                onChange={(date: Date | null) => setainspectionDateTime(date)}
                className="form-control"
                wrapperClassName="w-100"
                minDate={minDate}
                showIcon
                placeholderText="dd/mm/yyyy"
                dateFormat="dd/MM/yyyy"
                filterDate={(date) => !isWeekend(date) && !isHoliday(date)}
                disabled={disableInspectionDate}
                required
              />
              {isValidDate && (
                <div className="invalid-feedback">
                  Please provide a Date of Inspection.
                </div>
              )}

              {!isValidDate && (
                <p className="error-message">
                  Inspection date to be from Monday to Friday, excluding public
                  holidays.
                </p>
              )}
            </div>

            <div className="mb-2 ">
              <label
                htmlFor="exampleFormControlInput1"
                className="form-label mb-2"
              >
                10. Time of Inspection{" "}
                <span className="bracket-text">
                  (Please select a time between 09:00 to 17:00)
                </span>{" "}
                <span className="star">*</span>
              </label>
              {/* <input
                type="time"
                className={`form-control ${!isTimeValid ? "is-invalid" : ""}`}
                id="sInspectionTime"
                value={convertTo24HourFormat(ainspectionTime)}
                onChange={(event) => {
                  setaInspectionTime(event.target.value);
                  setTimeValid(isValidTime(event.target.value));
                }}
                disabled={disableInspectionDate}
                min="09:00"
                max="17:00"
                required
                pattern="^(0[9]|1[0-6]):[0-5][0-9]$"
              /> */}
              <DatePicker
                id="sInspectionTime"
                selected={ainspectionTime}
                onChange={(date: Date | null) => {
                  setaInspectionTime(date);
                }}
                className="form-control"
                wrapperClassName="w-100"
                showTimeSelect
                showTimeSelectOnly
                minTime={setHours(setMinutes(new Date(), 0), 9)}
                maxTime={setHours(setMinutes(new Date(), 0), 17)}
                placeholderText="HH:mm am"
                dateFormat="hh:mm aa"
                timeIntervals={30}
                disabled={disableInspectionDate}
                required
              />
              {!isTimeValid && (
                <div className="invalid-feedback mb-3">
                  Inspection time to be between 09:00 to 17:00.
                </div>
              )}
            </div>
            <div className="mb-2 ">
              <label
                htmlFor="exampleFormControlInput1"
                className="form-label mb-2"
              >
                11. Remarks
              </label>
              <input
                type="text"
                className="form-control"
                id="sRemarks"
                placeholder=""
                maxLength={500}
                value={aRemarks}
                onChange={(event) => setaRemarks(event.target.value)}
                disabled={viewMode}
              />
            </div>
            <div className="mb-2">
              <label
                htmlFor="exampleFormControlInput1"
                className={`form-label mb-2 ${
                  !isModeofContactSelected() ? "required" : ""
                }`}
              >
                12. Mode of contact for Inspection Updates{" "}
                <span className="star">*</span>{" "}
              </label>
              <div
                className={`form-check ${
                  !isModeofContactSelected() ? "is-invalid" : ""
                }`}
              >
                <input
                  className="form-check-input"
                  type="radio"
                  name="amodeofContact"
                  value="Email"
                  id="flexRadioDefault66"
                  checked={aModeofContact === 1}
                  onChange={() => setaModeofContact(1)}
                  disabled={viewMode}
                />
                <label
                  className="form-check-label"
                  htmlFor="flexRadioDefault66"
                >
                  Email
                </label>
              </div>
              {/* <div
                  className={`form-check ${
                    !isModeofContactSelected() ? "is-invalid" : ""
                  }`}
                >
                  <input
                    className="form-check-input"
                    type="radio"
                    name="amodeofContact"
                    value="SMS"
                    id="flexRadioDefault77"
                    checked={aModeofContact === 2}
                    onChange={() => setaModeofContact(2)}
                  />
                  <label
                    className="form-check-label"
                    htmlFor="flexRadioDefault77"
                  >
                    SMS
                  </label>
                </div> */}
              {submitted && !isModeofContactSelected() && (
                <div className="invalid-feedback">
                  Please select a Mode of Contact.
                </div>
              )}
            </div>
            <div className="mb-2">
              <label
                htmlFor="exampleFormControlInput1"
                className="form-label mb-2"
              >
                13. Inspection Contact Mobile <span className="star">*</span>
              </label>

              <div className="row">
                <div className="col-md-2">
                  <select
                    className="form-select"
                    aria-label="Default select example"
                    id="smobilecode"
                    value={amobilecode}
                    onChange={(e) => setaMobileCode(e.target.value)}
                    disabled={viewMode}
                    required
                  >
                    {countryMobileCodes.map((code: any) => (
                      <option key={code} value={code}>
                        {code}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="col-md-10">
                  <input
                    type="text"
                    aria-describedby="emailHelp"
                    className="form-control"
                    id="smobileNo"
                    placeholder=""
                    pattern="[0-9]+"
                    value={amobileNo}
                    onChange={amobileNoHandler}
                    disabled={viewMode}
                    maxLength={8}
                    required
                  />
                  <div className="invalid-feedback mb-3">
                    Please provide a mobile.
                  </div>
                  {!validaMobileNo && (
                    <div className="invalid-feedback">
                      Invalid mobile no. eg. +6591234567
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div>
              <button
                type="button"
                className="btn btn-success mt-4"
                onClick={handleUploadButtonClick}
                disabled={disableUpload}
              >
                Upload Files
              </button>
              <input
                type="file"
                ref={fileInputRef}
                className="csp-display-none"
                onChange={handleFileChange}
                multiple
              />
              {uploadedFiles &&
                uploadedFiles.map((fileName) => (
                  <div>
                    <p>Uploaded File: {fileName}</p>
                    {/* <p>File Size: {file.size} bytes</p> */}
                  </div>
                ))}
              {selectedFiles &&
                selectedFiles.map((file, index) => (
                  <div>
                    <p>
                      Selected File: {file.name}{" "}
                      <span
                        className="test-remove-icon"
                        onClick={() => removeSelectedFile(index)}
                      >
                        <i className="bi bi-x-circle-fill"></i>
                      </span>
                    </p>

                    {/* <p>File Size: {file.size} bytes</p> */}
                  </div>
                ))}
            </div>
          </div>

          <div className="mb-3">
            <ReCAPTCHA
              ref={recaptchaRef}
              sitekey={site_Key}
              onChange={() => setIsCaptchaValid(true)}
              onExpired={() => setIsCaptchaValid(false)}
            />
            {submitted && !isCaptchaValid && (
              <div className="error-message">
                Please complete the reCAPTCHA verification.
              </div>
            )}
          </div>

          <button
            type="submit"
            className="btn btn-success d-block mt-4"
            disabled={disableSubmit}
          >
            Submit
          </button>
          {isSubmiting && <Loader />}

          {errorMessage && <p>{errorMessage}</p>}
        </div>
      </form>
    </>
  );
};

export default ISRInspectionApplication;
